export default "__VITE_ASSET__PRM7Aw6n__"